<template>
  <FormFloat :title="$t('title')" @submit="login">
    <transition name="slide-down">
      <Notice v-if="message" :class="message.theme">
        {{ message.text }}
      </Notice>
    </transition>
    <Field
      autocomplete="email"
      :label="$t('email')"
      required
      type="email"
      validation
      :value.sync="email" />
    <Field
      autocomplete="current-password"
      :label="$t('password')"
      :maxlength="64"
      :minlength="8"
      required
      rules="password|passwordNumber|passwordNotAllNumeric"
      type="password"
      validation
      :value.sync="password" />
    <NoticeRecaptcha />
    <Btn class="danger" :isLoading="isLoggingIn" type="submit">
      {{ $t('button') }}
    </Btn>
    <Row class="foot">
      <Column :xs="12">
        <Route class="Btn link db" to="LoginForgot">
          {{ $t('forgot') }}
        </Route>
      </Column>
      <!--
      <Column :xs="6">
        <Route class="Btn link db" to="Signup">
          {{ $t('signup') }}
        </Route>
      </Column>
      -->
    </Row>
  </FormFloat>
</template>

<script>
import { actions, getters } from '@utils'
import AuthRedirect from '@mixins/AuthRedirect'
import FormFloat from '@forms/FormFloat'
import Message from '@mixins/Message'
import Meta from '@mixins/Meta'
import Recaptcha from '@mixins/Recaptcha'

export default {
  mixins: [
    AuthRedirect(),
    Message,
    Meta(),
    Recaptcha,
  ],
  components: { FormFloat },
  data() {
    return {
      email: '',
      password: '',
      isLoggingIn: false,
    }
  },
  computed: getters(),
  methods: {
    async login() {
      try {
        this.isLoggingIn = true
        await this.LOGIN(await this.injectRecaptcha({
          email: this.email,
          password: this.password,
        }, 'login'))
      } catch (error) {
        this.setErrorMessage(error)
      } finally {
        this.isLoggingIn = false
      }
    },
    ...actions('LOGIN'),
  },
}
</script>

<i18n>
{
  "en": {
    "meta": {
      "title": "Login"
    },
    "button": "Login",
    "forgot": "I forgot my password",
    "title": "Login",
    "email": "Email",
    "password": "Password",
    "signup": "Signup"
  }
}
</i18n>
